
export const name = "whisper-core";
export const version = "dev";
